export class CoverageLegend {

    public icon: string;
    public limitPer: string;
    public message: string;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/models/coverage-legend.model.ts